<div #formRow class="flex-gap-5" [ngClass]="{ 'justify-content-center': isOnProductsPage || isOnOrdersPage }">
  <div
    class="form-check"
    [ngClass]="{
      'checkbox-bulk-edits': isInBulkEdits,
      'checkbox-in-table': isOnProductsPage || isInOrderProducts || isOnOrdersPage
    }"
  >
    <input
      type="checkbox"
      class="form-check-input position-relative"
      [id]="id"
      [ngModel]="model"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onNgModelChange($event)"
      [attr.data-track-category]="trackCategory"
      [attr.data-track-action]="trackAction"
      [disabled]="inputDisabled"
      [attr.data-cy]="dataCySelector"
    />
    <label
      class="form-check-label"
      [ngClass]="{
        'cursor-pointer': cursorPointer,
        'mb-0': noMarginBottom,
        'text-nowrap': noWrap,
        'label-checkbox-in-table': isOnProductsPage || isInOrderProducts
      }"
      [for]="id"
    >
      {{ !(label | translate) ? label : (label | translate) }}
    </label>
  </div>
  @if (tooltipLabel && tooltipLabel.length > 0) {
    <info-tooltip [label]="tooltipLabel" [icon]="tooltipIcon"></info-tooltip>
  }
  @if (control && !control.pristine && !control.valid) {
    <div style="color: red">
      {{ errors | formError: formControlName | translate }}
    </div>
  }
</div>
